import React from 'react'
import { NavLink } from "react-router-dom";
import modalStyles from '../styles/syncModal.module.scss';
import { Row, Col } from 'react-flexbox-grid';
import { X } from 'react-feather';

const SyncModal = (props) => {

    return (
        <section className={[modalStyles.alertPrompt__background, modalStyles.__active].join(' ')}>
            <section className={modalStyles.alertPrompt__card}>
                <header className={modalStyles.alertPrompt__header}>
                    <Row start="xs" between="xs">
                        <Col xs={12}>
                            <h4 style={{textAlign:'center'}}>
                                {props.title}
                            </h4>
                            <span className={modalStyles.alertPrompt__close} onClick={props.onClose}>
                                <X size={24} color="#C61C33" />
                            </span>
                        </Col>
                    </Row>
                </header>
                <section className={modalStyles.alertPrompt__form}>
                    <div style={{ marginTop: 20, marginBottom:50, textAlign: 'center' }}>
                        Do you want to sync your Calendar?
                </div>
                    <Row center="xs" className={modalStyles.____divButtons}>
                        <Col xs={6}>
                            <button
                                className={modalStyles.__btn_modal}
                                onClick={props.onClose}              
                            >
                                No, Thanks
                            </button>
                        </Col>
                        <Col xa={6}>
                        <NavLink to="/settings">
                            <button
                                className={modalStyles.__btn_modal}
                                onClick={props.go}
                            >
                                Sync Calendars
                            </button>
                        </NavLink>
                        </Col>
                    </Row>
                </section>
            </section>
        </section>
    )
}

export default SyncModal